module.exports = __webpack_public_path__ + "static/media/unity.6721d30b.svg";